export const getDisplayNameByKey = <T extends string>(
  values: { key: T; display: string }[],
  key: T,
) => {
  const value = values.find((value) => value.key === key);

  return value ? value.display : null;
};
